export default __webpack_public_path__ + "static/media/Cars.8db1d854.svg";